import React from "react";

// ===== TOOLTIP COMPONENT FOR MINI SIDEBAR =====
const Tooltip = ({ children, text, show, position = "right" }) => {
  if (!show || !text) return children;

  return (
    <div
      style={{ position: "relative", display: "flex", alignItems: "center" }}
    >
      {children}
      <div
        style={{
          position: "absolute",
          left: position === "right" ? "120%" : "auto",
          right: position === "left" ? "120%" : "auto",
          top: "50%",
          transform: "translateY(-50%)",
          background: "rgba(0, 0, 0, 0.9)",
          color: "white",
          padding: "0.75rem 1rem",
          borderRadius: "0.75rem",
          fontSize: "0.875rem",
          fontWeight: "500",
          whiteSpace: "nowrap",
          zIndex: 10000,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          opacity: 1,
          visibility: "visible",
          transition: "all 0.2s ease",
          pointerEvents: "none",
        }}
      >
        {text}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: position === "right" ? "-6px" : "auto",
            right: position === "left" ? "-6px" : "auto",
            transform: "translateY(-50%) rotate(45deg)",
            width: "12px",
            height: "12px",
            background: "rgba(0, 0, 0, 0.9)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRight:
              position === "right"
                ? "none"
                : "1px solid rgba(255, 255, 255, 0.1)",
            borderBottom:
              position === "right"
                ? "none"
                : "1px solid rgba(255, 255, 255, 0.1)",
            borderLeft:
              position === "left"
                ? "none"
                : "1px solid rgba(255, 255, 255, 0.1)",
            borderTop:
              position === "left"
                ? "none"
                : "1px solid rgba(255, 255, 255, 0.1)",
          }}
        />
      </div>
    </div>
  );
};

export default Tooltip;
